import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from '@angular/router';

import { LoginSessionFacadeService } from '@digital-platform/users/services';

interface RouteGuardResult {
  status: 'fulfilled' | 'rejected';
  value?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class HomepageRedirectGuard implements CanActivate, CanActivateChild {
  constructor(
    private facade: LoginSessionFacadeService,
    private router: Router
  ) {}

  canActivate(): Promise<UrlTree> {
    return Promise.allSettled([
      this.facade.hasPermission('upload:manifest'),
      this.facade.hasPermission('admin_update:waste_profile'),
      this.facade.hasPermission('search:waste_profile'),
    ]).then((results: RouteGuardResult[]) => {
      if (this.facade.hasTargetUrl()) {
        const targetUrl = this.facade.getTargetUrl();
        if (targetUrl === '/') {
          return this.router.parseUrl('/dashboard');
        } else {
          return this.router.parseUrl(targetUrl);
        }
      }
      if (results[0]?.value && !results[1]?.value) {
        return this.router.parseUrl('/manifests');
      } else if (results[2]?.value) {
        return this.router.parseUrl('/search-waste-profile');
      } else {
        return this.router.parseUrl('/dashboard');
      }
    });
  }

  canActivateChild(): Promise<UrlTree> {
    return this.canActivate();
  }
}
